import {
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonPopover,
  IonToolbar,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  settingsOutline,
  gridOutline,
  listOutline,
  locationOutline,
  keyOutline,
  menuOutline,
  documentsOutline,
} from "ionicons/icons";
import "./Menu.css";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";

const appPages = [
  {
    imgIcon: gridOutline,
    title: "Dashboard",
    url: "/page/Dashboard",
  },
  {
    imgIcon: listOutline,
    title: "Devices",
    url: "/page/Devices",
  },
  {
    imgIcon: locationOutline,
    title: "Tracking",
    url: "/page/Tracking",
  },
  {
    imgIcon: keyOutline,
    title: "IAM",
    url: "/page/UserMgmt",
  },
  {
    imgIcon: documentsOutline,
    title: "Datasheets",
    url: "/page/Datasheets",
  },
  {
    imgIcon: settingsOutline,
    title: "Settings",
    url: "/page/Settings",
  },
];

const labels = ["Graphs", "Location", "Status"];

const Menu: React.FC<any> = () => {
  const [isThisBigScreen, setIsThisBigScreen] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  useEffect(() => {
    if (isDesktopOrLaptop !== isThisBigScreen) {
      setIsThisBigScreen(isDesktopOrLaptop);
    }
  }, [isDesktopOrLaptop]);

  const closeMenu = () => {
    const closeMenuButton = document.getElementById("menuClick");
    // console.log("menu button clicked: ", closeMenuButton);
    closeMenuButton?.click();
  };

  const gotoHomePage = () => {
    history.push("/page/Dashboard");
  };

  return (
    <IonMenu contentId="main" type={isThisBigScreen ? "push" : "overlay"}>
      <IonToolbar color="primary" mode="md">
        <IonListHeader className="customTitle">
          <img
            alt="icon"
            src="./assets/icon/brain.png"
            height={48}
            onClick={() => gotoHomePage()}
          />
          <IonLabel className="ion-padding ion-text-wrap">
            <h2>ARMOR</h2>
            <p className="customSmallerFont">
              The Battery Lifecycle Management Platform
            </p>
          </IonLabel>
        </IonListHeader>
        <IonList mode="md">
          {/* <IonListHeader>
            <img
              src="./assets/icon/brain.png"
              height={78}
              className="ion-padding"
            />
            ARMOR
          </IonListHeader>
          <IonNote>The Battery Lifecycle Management Platform</IonNote> */}
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem
                  className={
                    location.pathname === appPage.url ? "selected" : ""
                  }
                  routerLink={appPage.url}
                  routerDirection="none"
                  lines="none"
                  detail={false}
                >
                  <IonIcon mode="md" slot="start" icon={appPage.imgIcon} />
                  <IonLabel className="customSmallerFont">
                    {appPage.title}
                  </IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}
        </IonList>
        {/* <IonList id="labels-list">
          <IonListHeader>Labels</IonListHeader>
          {labels.map((label, index) => (
            <IonItem lines="none" key={index}>
              <IonIcon slot="start" icon={bookmarkOutline} />
              <IonLabel id={"label-hover-trigger" + index}>{label}</IonLabel>
              <IonPopover
                trigger={"label-hover-trigger" + index}
                triggerAction="hover"
              >
                <IonNote class="ion-padding">
                  Feature unavailable for you!
                </IonNote>
              </IonPopover>
            </IonItem>
          ))}
        </IonList> */}
      </IonToolbar>
      <IonFooter>
        <IonNote className="customSmallerFont">Powered By</IonNote>
        <img
          className="ion-padding-bottom"
          src="./assets/brand/renon-logo.png"
        />
      </IonFooter>
    </IonMenu>
  );
};

export default Menu;
